import { render, staticRenderFns } from "./ResourceEdit.vue?vue&type=template&id=47c61e97&"
import script from "./ResourceEdit.vue?vue&type=script&lang=js&"
export * from "./ResourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports